import React from 'react'


function Invite() {
  return (
    <section class="invite-section">
        <div class="auto-container">
            <div class="outer-box">
                <div class="icon-frame-2"></div>
                <div class="icon-frame-2 style-two"></div>
                <div class="sec-title light text-center">
                    <span class="sub-title">Invitation</span>
                    <h2>
                    We invite you to join our wedding <br />
                    ceremony
                    </h2>
                </div>
                <div class="invite-block-outer">
                    <div class="row">
                   
                    <div class="invite-block col-lg-4 col-md-4 col-sm-12 wow fadeInUp">
                        <div class="inner-box">
                        <div class="icon-box">
                            <i class="icon flaticon-wedding-arch-1"></i>
                        </div>
                        <div class="content-box">
                            <h4 class="title">Location</h4>
                            <div class="text">
                            Avala Hills, 234 Fulton Street <br />
                            Tuscany, IT
                            </div>
                        </div>
                        </div>
                    </div>

                    
                    <div class="invite-block col-lg-4 col-md-4 col-sm-12 wow fadeInUp" data-wow-delay="300ms">
                        <div class="inner-box">
                        <div class="icon-box">
                            <i class="icon flaticon-candelabra"></i>
                        </div>
                        <div class="content-box">
                            <h4 class="title">Time</h4>
                            <div class="text">
                            Sunday, February 18 2024, <br />
                            16:00 UTC
                            </div>
                        </div>
                        </div>
                    </div>

                    
                    <div class="invite-block col-lg-4 col-md-4 col-sm-12 wow fadeInUp" data-wow-delay="600ms">
                        <div class="inner-box">
                        <div class="icon-box">
                            <i class="icon flaticon-wedding-dress"></i>
                        </div>
                        <div class="content-box">
                            <h4 class="title">Venue</h4>
                            <div class="text">
                            Avala Hills, 234 Fulton Street <br />
                            Tuscany, IT
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Invite